(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('submitModal', submitModal);

    /* @ngInject */
    function submitModal() {
        var directive = {
            bindToController: true,
            templateUrl: 'submit-modal.tpl',
            controller: submitModalController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$root.$broadcast("submit-modal-opened");
        }
    }

    /* @ngInject */
    function submitModalController ($scope) {
        $scope.$on('sidebar-data', function(e, sbd) {

            $scope.vm.sidebarData = sbd[0];
            $scope.vm.regularPrice = sbd[1];
            var regularPiesCount = 0;
            for(var i in $scope.vm.sidebarData.pies) {
                var pname = $scope.vm.sidebarData.pies[i].name.toLowerCase();
                regularPiesCount += (pname.indexOf('deluxe') == -1) ? $scope.vm.sidebarData.pies[i].value : 0;
            }
            if ($scope.vm.sidebarData.couponData.quantity > regularPiesCount) {
                $scope.vm.remainder = ($scope.vm.sidebarData.couponData.quantity - regularPiesCount) * $scope.vm.regularPrice;
            } else {
                $scope.vm.remainder = '';
            }
            $scope.vm.showDiscount = $scope.vm.sidebarData.discountData && !$scope.vm.sidebarData.discountData.invalid && !isNaN($scope.vm.sidebarData.discountAmount);
        });
    }
})();